import { render, staticRenderFns } from "./SiderMenu.vue?vue&type=template&id=03b50bd0"
import script from "./SiderMenu.vue?vue&type=script&lang=js"
export * from "./SiderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports